import React, { useEffect } from 'react'
import {
  Anchor,
  AppShell,
  Avatar,
  Container,
  Group,
  Image,
  Indicator,
  Stack,
} from '@mantine/core'
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  redirect,
  useNavigate,
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  IconBell,
  IconLogout,
  IconMail,
  IconUser,
  IconUserCircle,
} from '@tabler/icons-react'

import { useIntl } from 'react-intl'
import centersRoutes from '../../routes/centers/centers.routes.js'
import fuelsStationsRoutes from '../../routes/fuel-stations/fuelStations.routes.js'
import ownFuelStationsRoutes from '../../routes/fuel-stations/ownFuelStations.routes.js'
import { centersPathname } from '../../routes/centers/pathname.js'
import { purchaseFuelsPathname } from '../../routes/purchase-fuels/pathaname.js'
import purchaseFuelRoutes from '../../routes/purchase-fuels/purchaseFuels.routes.js'
import { settingsRoutes } from '../../routes/settings/settings.routes.js'
import userRoutes from '../../routes/settings/user.routes.js'
import { getProfile } from '../../slices/profile.js'
import { MODULES } from '../../utils/constants/roles.js'
import { hasAccess, hasAccessModule } from '../../utils/helpers/rolesAccess.js'
import Sidebar from '../layout/sidebar/Sidebar.jsx'
import Header from '../layout/header/Header.jsx'
import UserNavLinkMenu from '../navlink/UserNavLinkMenu.jsx'
import ProtectedRoute from './ProtectedRoute.tsx'
// import './private-routes.scss'

import { fuelStations } from '../../routes/fuel-stations/pathname.js'

import logo from '../../assets/imgs/logos/logoMoureBlue.svg'
import routes from './routes'
import swalAlert from '../../utils/helpers/swalAlert.js'
import { logout } from '../../slices/auth'
import { appPathname, pathname } from '../../utils/constants/pathname.js'
import { themeCfg } from '../../theme/theme.ts'
import AppMenu from '../../component/layout/AppMenu.tsx'
import Centers from '../../views/centers/main/Centers.jsx'
import { cashRegistersPathnames } from '../../routes/cash-registers/pathname.js'
import { cashRegistersRoutes } from '../../routes/cash-registers/cashRegisters.routes.js'
import OwnFuelStationNavLinkMenu from '../navlink/OwnFuelStationNavLinkMenu.jsx'

const PrivateRoutes = () => {
  const mode = 'mantine'
  const intl = useIntl()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const Logout = async () => dispatch(logout())
  const profile = useSelector((state) => state.profile?.resp)
  const userRole = profile?.role

  const getProfileData = () => dispatch(getProfile())

  useEffect(() => {
    getProfileData()
  }, [])

  const handleLogout = async () => {
    const confirm = await swalAlert.warning(
      intl.formatMessage({ id: 'swal.title.logout' }),
      intl.formatMessage({ id: 'button.cancel' }),
      intl.formatMessage({ id: 'button.logout' }),
    )
    if (confirm?.isConfirmed) {
      await Logout()
      navigate(pathname.LOGIN)
    }
  }

  if (mode === 'mantine')
    return (
      <AppShell
        layout="alt"
        withBorder
        // header={{ height: { base: 85, [themeCfg?.breakpoint]: 55 } }}
        header={{ height: themeCfg?.headerSize }}
        navbar={{
          width: themeCfg?.navbarSize,
          breakpoint: themeCfg?.breakpoint,
          padding: 0,
          margin: 0,
          collapsed: { desktop: false, mobile: true },
        }}
        // footer={{ height: { base: 55, [themeCfg?.breakpoint]: 0 } }}
        footer={{ height: themeCfg?.footerSize }}
        padding="xs"
      >
        <AppShell.Header>
          <Group
            w="100%"
            h="100%"
            justify="space-between"
            px="md"
            bg="bg-container"
            visibleFrom={themeCfg?.breakpoint}
          >
            <Group px="md">
              <Image src={logo} alt="gesMoure" h={36} />
            </Group>

            <Group justify="flex-end" pr="md">
              {/* <Indicator color="moure-orange" offset={12} size={12}> */}
              <Avatar
                radius="xl"
                variant="outline"
                color="moure-blueprimary"
                opacity={0.2}
              >
                <IconBell />
              </Avatar>
              {/* </Indicator> */}
              <Avatar
                radius="xl"
                variant="outline"
                color="moure-blue"
                opacity={0.2}
              >
                <IconMail />
              </Avatar>
              <Avatar
                radius="xl"
                variant="outline"
                color="moure-blue"
                onClick={() => navigate(appPathname.PROFILE)}
                style={{ cursor: 'pointer' }}
              >
                <IconUserCircle />
              </Avatar>
              <Avatar
                radius="xl"
                variant="outline"
                color="moure-blue"
                onClick={() => handleLogout()}
                style={{ cursor: 'pointer' }}
              >
                <IconLogout />
              </Avatar>
            </Group>
          </Group>

          <Stack
            w="100%"
            gap={0}
            h={50}
            hiddenFrom={themeCfg?.breakpoint}
            bg="moure-blue"
          >
            <Group w="100%" h={20} justify="center">
              <Group>
                <Anchor
                  c="white"
                  fw="bolder"
                  onClick={() => navigate(appPathname.PROFILE)}
                >
                  {profile?.name}
                </Anchor>
              </Group>
              <Group>
                <Anchor c="white" onClick={() => navigate(appPathname.PROFILE)}>
                  {userRole?.role}
                </Anchor>
              </Group>
            </Group>
            <AppMenu mode="horizontal" h={30} />
          </Stack>
        </AppShell.Header>

        <AppShell.Navbar>
          <AppMenu mode="vertical" />
        </AppShell.Navbar>

        {/* <AppShell.Footer bg="transparent" withBorder zIndex={0}>
            </AppShell.Footer> */}

        <AppShell.Main
          withBorder
          bg={themeCfg?.debug ? 'moure-blue' : 'bg-container'}
        >
          <Container
            fluid
            h="100%"
            bg={themeCfg?.debug ? 'gray' : 'bg-container'}
          >
            <Routes>
              {routes.private.map(({ path, element, name }) => (
                <Route key={name} path={path} element={element} />
              ))}
              {getCashRegistersRouting(userRole)}
              {getSettingsRouting(userRole)}
              {getUsersRouting(userRole)}
              {getFuelStationsRouting(userRole)}
              {getOwnFuelStationsRouting(userRole)}
              {getCentersRouting(userRole)}
              {getPurchaseFuelsRouting(userRole)}
            </Routes>
          </Container>
        </AppShell.Main>
      </AppShell>
    )

  return (
    <div className="container">
      <div className="sidebar-desktop sidebar-mobile">
        <Sidebar />
      </div>
      <div className="wrapper-view">
        <div className="menu-header">
          <Header />
        </div>
        <div className="viewsContainer containerWrapper">
          <Routes>
            {routes.private.map(({ path, element, name }) => (
              <Route key={name} path={path} element={element} />
            ))}
            {getCashRegistersRouting(userRole)}
            {getSettingsRouting(userRole)}
            {getUsersRouting(userRole)}
            {getFuelStationsRouting(userRole)}
            {getOwnFuelStationsRouting(userRole)}
            {getCentersRouting(userRole)}
            {getPurchaseFuelsRouting(userRole)}
          </Routes>
        </div>
      </div>
    </div>
  )
}

const getSettingsRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.SETTINGS,
    modulePath: settingsRoutes[0].path,
    moduleRoutes: settingsRoutes,
    userRole,
  })

const getUsersRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.USERS,
    modulePath: userRoutes.USERS,
    moduleRoutes: userRoutes,
    userRole,
    NavLinkMenuComponent: <UserNavLinkMenu />,
  })

const getFuelStationsRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.FUELSTATIONS,
    modulePath: fuelStations.FUEL_STATIONS,
    moduleRoutes: fuelsStationsRoutes,
    userRole,
    defaultRoute: 0,
    // NavLinkMenuComponent: <NavLinkMenu navLinks={fuelStationsMenu} version={1} />
  })

const getOwnFuelStationsRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.FUELSTATIONS,
    modulePath: fuelStations.FUEL_STATIONS,
    moduleRoutes: ownFuelStationsRoutes,
    userRole,
    NavLinkMenuComponent: <OwnFuelStationNavLinkMenu />,
  })

const getCentersRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.CENTERS,
    modulePath: centersPathname.CENTERS,
    moduleRoutes: centersRoutes,
    userRole,
    // NavLinkMenuComponent: <NavLinkMenu navLinks={centersMenu} version={1} />
  })

const getPurchaseFuelsRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.PURCHASE_FUEL,
    modulePath: purchaseFuelsPathname.PURCHASE,
    moduleRoutes: purchaseFuelRoutes,
    userRole,
    // NavLinkMenuComponent: <NavLinkMenu navLinks={purchaseFuels} version={1} />
  })

const getCashRegistersRouting = (userRole) =>
  createModuleRouting({
    moduleName: MODULES.CASH_REGISTERS,
    modulePath: cashRegistersPathnames.CASH_REGISTERS,
    moduleRoutes: cashRegistersRoutes,
    userRole,
  })

const createModuleRouting = ({
  moduleName,
  modulePath,
  moduleRoutes,
  userRole,
  NavLinkMenuComponent,
}) => {
  const hasEntryAccess =
    hasAccessModule(userRole, moduleName) ||
    moduleName === 'accountingEntry' ||
    moduleName === 'cashRegisters'

  return (
    hasEntryAccess && (
      <Route
        path={modulePath}
        element={
          <ProtectedRoute isAllowed={hasEntryAccess}>
            <Outlet />
          </ProtectedRoute>
        }
      >
        {moduleRoutes.map(({ path, element, name, role }) => {
          return (
            <Route
              key={name}
              path={path}
              element={
                <div>
                  {NavLinkMenuComponent}
                  {/* <ProtectedRoute isAllowed={role ? hasAccess(userRole, role) || moduleName==='accountingEntry' : hasEntryAccess} > */}
                  <ProtectedRoute
                    isAllowed={
                      role ? hasAccess(userRole, role) : hasEntryAccess
                    }
                  >
                    {element}
                  </ProtectedRoute>
                </div>
              }
            />
          )
        })}
      </Route>
    )
  )
}

export default PrivateRoutes
